import {
  QUERY_KEY_MANAGEMENT_SEARCH_UNITS,
  QUERY_KEY_MANAGEMENT_SEARCH_UNITS_COUNT,
  QUERY_KEY_MANAGEMENT_SEARCH_UNITS_INFINITE
} from '@apps-common/apis/management/unit'
import { QUERY_MANAGEMENT_GET_UNIT_ACTIVE } from '@apps-common/apis/management/unit-active'
import {
  QUERY_GET_UNIT_GENERIC_DETAILS,
  QUERY_KEY_PORTAL_SEARCH_UNITS,
  QUERY_KEY_PORTAL_SEARCH_UNITS_COUNT,
  QUERY_KEY_PORTAL_SEARCH_UNITS_INFINITE
} from '@apps-common/apis/portal/unit'
import {
  QUERY_GET_UNIT_ACTIVATION_BY_ID,
  QUERY_SEARCH_UNIT_ACTIVATIONS,
  QUERY_SEARCH_UNIT_ACTIVATIONS_COUNT,
  QUERY_SEARCH_UNIT_ACTIVATIONS_INFINITE
} from '@apps-common/apis/portal/unit-activations'
import { IAppNavigationOptions } from '@apps-common/hooks/useNavigation'
import { queryClient } from '@apps-common/lib'
import { IActivationServiceRequestModel } from '@apps-common/types/portal/service-request'
import { ROUTE_UNIT_ACTIVATIONS } from '@apps-radionet-portal-root/src/config/private-routes'

export const afterActivationUpdate = (
  data: IActivationServiceRequestModel,
  navigateReplace: (opts: IAppNavigationOptions) => void,
  purge: () => void
) => {
  // purge garbage collector to avoid any actions running
  purge()

  queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS_COUNT() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS_INFINITE() })

  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS_COUNT() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS_INFINITE() })

  queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_GENERIC_DETAILS(data?.unitId) })
  queryClient.invalidateQueries({ queryKey: QUERY_MANAGEMENT_GET_UNIT_ACTIVE(data?.unitId) })
  queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_ACTIVATION_BY_ID() })

  queryClient.invalidateQueries({ queryKey: QUERY_SEARCH_UNIT_ACTIVATIONS_COUNT() })
  queryClient.invalidateQueries({ queryKey: QUERY_SEARCH_UNIT_ACTIVATIONS() })
  queryClient.invalidateQueries({ queryKey: QUERY_SEARCH_UNIT_ACTIVATIONS_INFINITE() })

  navigateReplace({ routeUrl: ROUTE_UNIT_ACTIVATIONS.buildPath(), route: ROUTE_UNIT_ACTIVATIONS })
}
